import React from 'react';
import { motion } from 'framer-motion';
import { Star, XCircle } from 'lucide-react';
import { ScrollButton } from './Shared';
const stats = [{
  value: '+500',
  label: 'profes confían'
}, {
  value: '12+6',
  label: 'Tomos + Bonus'
}, {
  value: '4.9/5',
  label: 'calificación ⭐',
  isRating: true
}, {
  value: '🌎',
  label: '+15 países',
  isFlag: true
}];
const initialTestimonials = [{
  initials: 'MP',
  quote: 'Organicé todo el mes en una tarde. Nunca más llego al estudio sin saber qué dar.',
  author: 'María P., Madrid',
  role: 'Profesora de Pilates en Estudio Propio'
}, {
  initials: 'CG',
  quote: 'Mis alumnos de nivel intermedio progresaron más en un mes que en los tres anteriores.',
  author: 'Claudia G., Ciudad de México',
  role: 'Profesora de Pilates en Academia Privada'
}, {
  initials: 'FR',
  quote: 'Antes tardaba 1 hora armando una sesión. Ahora son 5 minutos.',
  author: 'Federico R., Bogotá',
  role: 'Profesor de Pilates Reformer Independiente'
}];
const painPoints = ['Llegas al estudio sin saber exactamente qué sesión vas a dar', 'Tus alumnos no progresan porque no hay un orden claro de contenidos ni una progresión real', 'Tienes grupos con niveles mezclados y no sabes cómo manejarlos sin que nadie se quede atrás', 'Cuando hay feriado o ausencia pierdes la continuidad de la práctica y todo se desordena', 'No puedes justificar un aumento de precio porque no tienes nada sistematizado ni documentado', 'Usas siempre los mismos ejercicios porque te quedaste sin ideas y no sabes cómo variar', 'Llegas a casa agotada mentalmente no por dar clase sino por haber tenido que improvisar', 'Nadie valora tu trabajo porque no se ve reflejado en el progreso concreto de tus alumnos'];
export const Problem = () => {
  return <>
      {/* Dark Social Proof + Testimonials Section */}
      <section className="bg-brand-charcoal py-16 sm:py-20" data-id="element-155">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-156">
          {/* Stats Row */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-y-10 gap-x-6 mb-16 sm:mb-20" data-id="element-157">
            {stats.map((stat, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.08
          }} className="text-center" data-id="element-158">
                <div className={`font-serif font-bold text-white mb-2 ${stat.isFlag ? 'text-4xl sm:text-5xl' : 'text-4xl sm:text-5xl md:text-6xl'}`} data-id="element-159">
                  {stat.value}
                </div>
                <div className="text-brand-terracotta text-sm sm:text-base font-medium flex items-center justify-center gap-1" data-id="element-160">
                  {stat.isRating ? <>
                      calificación{' '}
                      <Star className="text-brand-gold fill-current inline" size={16} data-id="element-161" />
                    </> : stat.label}
                </div>
              </motion.div>)}
          </div>

          {/* Initial Testimonials */}
          <div className="grid md:grid-cols-3 gap-6" data-id="element-162">
            {initialTestimonials.map((t, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.1
          }} className="bg-white/[0.04] backdrop-blur-sm border border-white/10 rounded-2xl p-6" data-id="element-163">
                <div className="flex items-center gap-3 mb-5" data-id="element-164">
                  <div className="w-10 h-10 bg-brand-terracotta/20 text-brand-terracotta rounded-full flex items-center justify-center font-bold text-sm border border-brand-terracotta/30" data-id="element-165">
                    {t.initials}
                  </div>
                  <div className="flex gap-0.5" data-id="element-166">
                    {[...Array(5)].map((_, j) => <Star key={j} className="text-brand-gold fill-current" size={14} data-id="element-167" />)}
                  </div>
                </div>
                <p className="text-white leading-relaxed mb-5 text-[15px]" data-id="element-168">
                  "{t.quote}"
                </p>
                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-169">
                  — {t.author} | {t.role}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Pain Points */}
      <section className="py-20 bg-brand-cream" data-id="element-170">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-171">
          <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-brand-sand" data-id="element-172">
            <div className="bg-brand-charcoal text-white p-10 text-center" data-id="element-173">
              <h2 className="text-3xl md:text-4xl font-serif font-bold mb-4" data-id="element-174">
                Si eres profe de Pilates, esto te va a sonar conocido:
              </h2>
            </div>

            <div className="p-8 md:p-12" data-id="element-175">
              <div className="space-y-6 mb-12" data-id="element-176">
                {painPoints.map((point, i) => <motion.div key={i} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: i * 0.1
              }} className="flex items-start gap-4" data-id="element-177">
                    <XCircle className="text-red-500 flex-shrink-0 mt-1" size={24} data-id="element-178" />
                    <p className="text-lg text-gray-700 leading-relaxed" data-id="element-179">
                      <span className="font-semibold text-brand-charcoal" data-id="element-180">
                        ❌
                      </span>{' '}
                      {point}
                    </p>
                  </motion.div>)}
              </div>

              <div className="text-center" data-id="element-181">
                <h3 className="text-2xl font-serif font-bold text-brand-charcoal mb-8 italic" data-id="element-182">
                  "¿Cuántas sesiones más vas a improvisar?"
                </h3>
                <ScrollButton className="w-full sm:w-auto bg-brand-charcoal hover:bg-black text-white text-lg font-bold py-4 px-8 rounded-xl shadow-lg transition-all transform hover:-translate-y-1" data-id="element-183">
                  👉 BASTA DE IMPROVISAR — QUIERO MI PILATES 360
                </ScrollButton>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>;
};